<mat-form-field class="date-picker-container" [ngClass]="{ dateClass: dateClass, 'w-100': fullWidth }">
  <mat-label>{{ dateLabel }}</mat-label>
  <input matInput #inputDate  [min]="minDate" [max]="maxDate"
  [matDatepicker]="picker" (dateChange)="getDateEmit()"
     [formControl]="fechaCtrl" >
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker disabled="false"></mat-datepicker>
</mat-form-field>
